import { FunctionComponent } from "react";
import { GameInfoProps } from "../../type";
import { Rule } from "./type";
import PiratesTreasureUtils from "./utils";

export const PiratesTreasureRuleView: FunctionComponent<GameInfoProps> = ({
  data,
}) => {
  const {
    payouts = {},
    buyFreeSpinRate = 50,
    givenFreeSpin = {},
  } = data as Rule;
  const candyPayouts = Object.entries(payouts);
  const halfCandyCount = candyPayouts.length / 2;
  const payoutElement = [
    <tr key={2} className="text-center">
      {candyPayouts.slice(halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {PiratesTreasureUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
    <tr key={1} className="text-center">
      {candyPayouts.slice(0, halfCandyCount).map(([symbol, payout], i) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {PiratesTreasureUtils.convertSymbol(+symbol)}
          </div>
          <div className="">{payout}</div>
        </td>
      ))}
    </tr>,
  ];
  const specialSymbols = [
    <tr key={1} className="text-center">
      {[4, 2, 3].map((symbol) => (
        <td key={`symbol-${symbol}`}>
          <div className="d-inline-block symbol">
            {PiratesTreasureUtils.convertSymbol(+symbol)}
          </div>
        </td>
      ))}
    </tr>,
  ];
  return (
    <>
      <h5 className="card-title">Game Rules</h5>
      <div className="card-text">
        <h6>Payout Table</h6>
        <br />
        <table className="w-100">
          <tbody>{payoutElement}</tbody>
        </table>
      </div>
      <p className="card-text">
        Pirates Treasure is a cascading Match-3 slot game, with a new exciting
        bonus payouts <br />
      </p>
      <p className="card-text">
        Symbols explode and more symbols cascade down, until no more matches can
        be made.
      </p>
      <h6>How it works?</h6>
      <p className="card-text">
        Player if the player gets 3 or less in the normal spin, no Link Bonus
        free spin is awarded.
        <br />
        If there are 3 or less in normal spin, the player does NOT get any
        winnings even if there are numbers on the scatter symbol in normal spin
      </p>

      <h6>What is 4 Link Bonus Scatter Symbols?</h6>
      <p className="card-text">
        4 Link Bonus Scatter symbols appearing anywhere during a round will
        trigger the "Link Bonus" reel spin bonus feature.
      </p>

      <h6>Multipliers</h6>

      <p className="card-text">
        - Highest Bonus Multiplier: 10x from bet amount
        <br />
        - Bonus Range: 1x ~ 10x
        <br />
        e.g. if bet amount is $1, Scatter symbol range value = $1 ~ $10-
      </p>

      <h6>How to trigger free spin state?</h6>
      <p className="card-text">
        4 scatter symbols will trigger 'Free spin' Link Bonus Scatter Symbols
        Game feature.
        <br />
        The player can also 'Buy Free Spin' to enter this mode.
      </p>

      <h6>Buy Free Spins</h6>
      <p className="card-text">
        <img src="/pt/buyfreespins.png" alt="buyfreespins" />
        <br />
        - A 'Buy Free Spin' button is available to the player to purchase at a
        rate of 50x the bet amount (final amount subject to balancing) spins and
        a chance for more!
        <br />
        - On purchase, a new grid is created to induce free spin
        <br />- The payouts within the free spin is reduced (final amount
        subject to balancing).-
      </p>
    </>
  );
};
